export default "__VITE_ASSET__BolGA7hI__"